import React from "react";

function P(props){
    return(
    <>
    <p className={props.name}>{props.title}</p>
    </>);
}
export default P;